module.exports = __webpack_public_path__ + "static/media/coffee-togo.18d023a5.svg";